module.exports = __webpack_public_path__ + "img/17314496.b6130ef1.png";